////////LIBRARY/////////
import { useEffect, useState } from 'react'
import { cloneDeep, orderBy, find } from 'lodash'

const SORT_ELEM = ['desc', 'asc']

function UseListSort(columns, data) {
	const [tableData, setTableData] = useState(cloneDeep(data))
	const [dataToSort, setDataToSort] = useState('')
	const [sortDirection, setSortDirection] = useState(0)
	const [trigger, setTrigger] = useState({
		data: '',
		trigger: 0,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSortDirection = () => {
		const idxIncrease = sortDirection + 1
		return idxIncrease >= SORT_ELEM.length ? 0 : idxIncrease
	}

	const handleChangeDataSorted = (column) => {
		setDataToSort(trigger.data)
		setTableData(orderBy(tableData, [column.sortedBy || column.dataHook], [SORT_ELEM[sortDirection]]))
	}

	const handleChangeSorted = (column) => {
		const idx = handleSortDirection()
		setTableData(orderBy(tableData, [column.sortedBy || column.dataHook], [SORT_ELEM[sortDirection]]))
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		const column = find(columns, { headerName: trigger.data, sortable: true })
		if (!column) {
			return
		}

		if (trigger.data !== dataToSort) {
			return handleChangeDataSorted(column)
		}

		handleChangeSorted(column)
	}, [trigger, data])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return [tableData, trigger, setTrigger, setTableData, sortDirection, setSortDirection]
}

export default UseListSort
